/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShippingOrderItemDetail {
  costPrice?: number;
  defaultImageURL?: string;
  discount?: number;
  externalId?: number;
  internalEAN?: string;
  invoicePrice?: number;
  millenniumSKU?: string;
  productId?: number;
  productVariantId?: number;
  productVariantName?: string;
  quantity?: number;
  rewardId?: number;
  salePoint?: number;
  salePrice?: number;
  shippingOrderId?: number;
  shippingOrderItemId?: number;
  shippingOrderTypeId?: number;
  shippingOrderTypeName?: string;
  subscriberEditionId?: number;
}
